/**
 * Vue composable for common calendar screens.
 * @author cm359n
 */
import { toMoment } from '@fullcalendar/moment'
// import Hammer from 'hammerjs'

export const useCalendarMethods = () => {
    // Short hand to get the FullCalendar instance.
    // this needs us to pass the ref from the main Vue
    const fc = (fc_ref) => {
        // this triggers an error on non-calendar pages sometimes
        if (fc_ref) {
          return fc_ref.value.getApi()
        } else {
          console.log('this page does not have a fc ref')
          return null
        }
      }
    
    // Short hand to go to next calendar page.
    const next = (fc_ref) => {
      fc(fc_ref).next()
    }

    // Short hand to go to previous calendar.
    const prev = (fc_ref) => {
        fc(fc_ref).prev()
    }

    /* The server still expects dates in unix format for older versions of FullCalendar.
    This method does the conversion. */
   const dateToUnixTs = (date) => {
      return date.getTime() / 1000 | 0
    }

    // Short hand to transform date to a moment.js object.
    const moment = (date, fc_ref) => {
      return toMoment(date, fc(fc_ref))
    }

    return {
        dateToUnixTs,
        fc,
        moment,
        next,
        prev,
    }
}
